import { Component, OnInit } from '@angular/core';
import {AuthService} from "../auth/auth.service";
import {MatDialog} from "@angular/material/dialog";
import {SignInComponent} from "../sign-in/sign-in.component";

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {

  constructor(public auth: AuthService, public dialog: MatDialog) { }

  ngOnInit(): void {
  }

  signOut(): void {
    this.auth.signOut()
  }

  openSignInDialog() {
    this.dialog.open(SignInComponent, {
      width: '500px',
      autoFocus: false
    });
  }
}
